export function FieldLabel({ htmlFor, children }: { htmlFor: string; children: string }) {
  return (
    <label htmlFor={htmlFor} className="text-meta font-medium text-slate-600 dark:text-slate-300">
      {children}
    </label>
  );
}
